export default __webpack_public_path__ + "static/3-cfddcd84c6cebc9cbad3b61529327e74.webp";